import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const RouterLink = styled(Link)`
  color: #4948ac;
  font-size: 13px;
  font-weight: bold;
  text-decoration: none;
  margin: 0.25em;
  &:hover {
    color: #2dcaff;
    transition: 0.5s;
  }
`;
